import { render, staticRenderFns } from "./TwoShowcaseCardItem.vue?vue&type=template&id=58325b50&scoped=true&"
import script from "./TwoShowcaseCardItem.vue?vue&type=script&lang=ts&"
export * from "./TwoShowcaseCardItem.vue?vue&type=script&lang=ts&"
import style0 from "./TwoShowcaseCardItem.vue?vue&type=style&index=0&id=58325b50&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58325b50",
  null
  
)

export default component.exports